import React from 'react';
import L from 'leaflet';
import 'leaflet.fullscreen';
import {useRef, useEffect} from 'react';
import {useMap} from 'react-leaflet';
import { FullscreenControlStyles } from './styled';

export function FullscreenControl(props) {
  const map = useMap();
  const ctrl = useRef(L.control.fullscreen({
    title: {
      'false': 'View neighborhood map in fullscreen', // Aligned with Walkabout language guidelines
      'true': 'Exit fullscreen view'
    },
    ...props
  }));

  useEffect(() => {
    ctrl.current.addTo(map);
    
    // Add accessibility and mobile-friendly attributes
    if (ctrl.current._container) {
      const button = ctrl.current._container.querySelector('.leaflet-fullscreen-icon');
      if (button) {
        button.setAttribute('aria-label', 'Toggle fullscreen map view');
        button.setAttribute('role', 'button');
      }
    }
    
    return () => {
      ctrl.current.remove();
      ctrl.current.link?.remove();
    };
  }, [map]);

  // Return the styled-component to ensure styles are injected into the DOM
  return <FullscreenControlStyles />;
}
